module.exports = __webpack_public_path__ + "static/media/UniviaPro-Regular.a34b56be.otf";